import { useMutation, useQuery } from "@tanstack/react-query";
import useAxiosInstance from "./axiosInstance.utils";
import { errorFormat } from "./handleError.utils";
import { onSuccessMessage, queryClient } from "./reactQuery.utils";

/**
 * :::::::MUTATIONS:::::::::::
 */

export function useCreateDhakaCityMutation(keyData) {
  const { postApi } = useAxiosInstance();
  async function createDhakaCityApi(data) {
    try {
      const api = `/dhaka-city`;
      const apiResponse = await postApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["createDhakaCityApi", ...keyData],
    mutationFn: (data) => createDhakaCityApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("dhaka-cities");
      onSuccessMessage(data, 201);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, createDhakaCity: mutateAsync };
}

export function useUpdateDhakaCityMutation(keyData) {
  const { putApi } = useAxiosInstance();
  async function updateDhakaCityApi(data) {
    try {
      const api = `/dhaka-city`;
      const apiResponse = await putApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }
  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["updateDhakaCityApi", ...keyData],
    mutationFn: (data) => updateDhakaCityApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("dhaka-cities");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, updateDhakaCity: mutateAsync };
}

export function useDeleteDhakaCityMutation(keyData) {
  const { deleteApi } = useAxiosInstance();
  async function deleteDhakaCityApi(id) {
    try {
      const api = `/dhaka-city/${id}`;
      const apiResponse = await deleteApi(api);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["deleteDhakaCityApi", ...keyData],
    mutationFn: (data) => deleteDhakaCityApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("dhaka-cities");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, deleteDhakaCity: mutateAsync };
}

/**
 * :::::::QUERIES:::::::::::
 */
export function useGetAllDhakaCityQuery({ query, options = {}, key = "" }) {
  const { getApi } = useAxiosInstance();
  async function getAllDhakaCityApi(query) {
    try {
      const api = `/dhaka-cities${query ?? ""}`;
      const apiResponse = await getApi(api);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const {
    data,
    isPending: loading,
    ...rest
  } = useQuery({
    queryKey: [`getAllDhakaCity-${query ?? ""}${key ? "-" + key : ""}`],
    queryFn: () => getAllDhakaCityApi(query),
    ...options
  });
  const newData = data?.data?.data ?? {};
  const parents = data?.data?.parents ?? [];
  return { data: newData, parents, loading, ...rest };
}
